import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { LazyLoadEvent } from 'primeng/api';
import { Observable } from 'rxjs';

import { ListaResultset } from '../list/lista-resultset.interface';
import { ListaUtil } from '../list/lista-util';
import { ListaComponent } from '../list/lista.component';
import { Metadata } from '../list/metadata/metadata.component';
import { AmbienteService } from '../multi-tenancy/ambiente.service';
import { CabecalhoDeImpressaoComponent } from './components/cabecalho-de-impressao/cabecalho-de-impressao.component';
import { RelatorioController } from './dto/relatorio-controller';
import { IRelatorioFiltro } from './dto/relatorio-filtro.interface';
import { RelatorioFiltros } from './dto/relatorio-filtros.model';


@Component({
  selector: 'app-relatorio',
  templateUrl: './relatorio.component.html',
  styleUrls: ['./relatorio.component.css']
})
export class RelatorioComponent<M, F> implements OnInit {

  private debug = true;

  @ViewChild('appCabecalhoDeImpressao') private appCabecalhoDeImpressao: CabecalhoDeImpressaoComponent;

  @ViewChild('lista')  public listaComponent: ListaComponent;
  listaUtil: ListaUtil;
  acao = 'formulario';

  @Input() nomeRelatorio = '';

  @Input() controller: RelatorioController<M, F> = null;

  // filtros
  filtros: RelatorioFiltros<F>;
  
  constructor(
    private ambienteService: AmbienteService
  ) { 
    this.listaUtil = new ListaUtil();
  }

  ngOnInit() {
    if ( this.debug ) { console.log('relatorio.component : ngOnInit') };
  }

  aoMudarPagina(event: LazyLoadEvent) {

    if ( this.debug ) { console.log('relatorio.component : aoMudarPagina') };

    const pagina = this.listaUtil.calculaPagina(event);
    this.controller.carregarRelatorio(pagina);
  }

  carregarRelatorio(): void {
    if ( this.debug ) { console.log('relatorio.component : carregarRelatorio') };
  }

  exibirCarregando(): void {
    this.listaComponent.setLoading(true);
  }

  getListaObservable(): Observable<ListaResultset<M>> {

    if ( this.debug ) { console.log('relatorio.component : getListaObservable') };

    return this.controller.getListaObservable(null);
  }
  
  atualizaCabecalho(): void {
    this.appCabecalhoDeImpressao.carregarDados();
  }

  setListaResultset(lista: ListaResultset<M>, cols: Metadata[]): void {

    if ( this.debug ) { console.log('relatorio.component : setListaResultset') };

    this.atualizaCabecalho();

    this.listaComponent.lista.cols = cols;
    this.listaComponent.setListaResultset(lista);

    this.listaComponent.recarregarListagemHack();
    this.listaComponent.setLoading(false);
  }

  limparResultado(): void {
    if ( this.debug ) { console.log('relatorio.component : limparResultado') };

    const lista: ListaResultset<M> = new ListaResultset<M>();
    this.listaComponent.setListaResultset(lista);
  }

  adicionarFiltro(filtro: IRelatorioFiltro): void {
    if ( this.debug ) { console.log('relatorio.component : adicionarFiltro') };
    if ( !this.filtros ) {
      this.filtros = new RelatorioFiltros();
    }
    
    this.filtros.add(filtro);
  }

  limparFiltro(): void {
    if ( this.debug ) { console.log('relatorio.component : limparFiltro') };
    this.filtros = new RelatorioFiltros();
  }

  setFiltro(filtros: RelatorioFiltros<F>): void {
    if ( this.debug ) { console.log('relatorio.component : setFiltro') };
    this.filtros = filtros;
  }

}
